import type { HTMLAttributes } from 'react';
import { cn } from './cn';

/** DESIGN.md › card: white, 12px radius, hairline border, 16px padding. */
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'rounded-md border border-border-weak bg-surface p-content-sm text-on-surface',
        className,
      )}
      {...props}
    />
  );
}
